// ─────────────────────────────────────────────────────────────
//  R&R Food Products — Complete Product Catalogue
//  Prices from client's handwritten list (May 2026)
// ─────────────────────────────────────────────────────────────

export const CATEGORIES = [
  'All Products',
  'Spicy Namkeen',
  'Bhujha & Chatpate Bhujha',
  'Fryums',
  'Chips/Kurkure/Cheese Balls',
  'Puffs',
  'Diet & Health',
];

export const VARIETIES = [
  { id: 'v1', name: 'Spicy Namkeen',            description: 'Crunchy, flavourful, and irresistible.', image: '/images/products/kushal_all_in_opne_namkeen.png' },
  { id: 'v2', name: 'Bhujha & Chatpate Bhujha', description: 'Crunchy, flavourful, and irresistible.', image: '/images/products/kushal_chatapate.png' },
  { id: 'v3', name: 'Fryums',                   description: 'Crunchy, flavourful, and irresistible.', image: '/images/products/Korean_Hot_Spicy.png' },
  { id: 'v4', name: 'Chips/Kurkure/Cheese Balls', description: 'Crunchy, flavourful, and irresistible.', image: '/images/products/Potato.jpg' },
  { id: 'v5', name: 'Puffs',                    description: 'Crunchy, flavourful, and irresistible.', image: '/images/products/Jungle_Janawar.png' },
  { id: 'v6', name: 'Diet & Health',            description: 'Crunchy, flavourful, and irresistible.', image: '/images/products/die_mixture.jpg' },
];

export const PRODUCTS = [

  // ── SPICY NAMKEEN ──────────────────────────────────────────
  {
    id: 1,
    name: 'Kushal Namkeen',
    category: 'Spicy Namkeen',
    price: 5, unit: '12g',
    description: 'Authentic Nepali mixed namkeen — crunchy and full of spice.',
    image: '/images/products/aa_khushal_namkeen_latest_.png',
    sizeOptions: [
      { size: '12g',  price: 5   },
      { size: '25g',  price: 10  },
      { size: '125g', price: 50  },
      { size: '250g', price: 100 },
      { size: '800g', price: 300 },
    ],
    sizes: ['12g','25g','125g','250g','800g'],
    reviews: 214, rating: 5,
    ingredients: 'Chickpea flour, vegetable oil, peanuts, rice flakes, spices & condiments.',
    allergy: 'Contains peanuts. May contain traces of soy and mustard.',
    badge: 'Bestseller',
  },
  {
    id: 2,
    name: 'Kushal All In One Namkeen',
    category: 'Spicy Namkeen',
    price: 10, unit: '20g',
    description: 'Kushal brand premium all-in-one namkeen mix — No. 1 quality, 100% vegetarian.',
    image: '/images/products/kushal_all_in_opne_namkeen.png',
    sizeOptions: [
      { size: '20g', price: 10 },
      { size: '40g', price: 20 },
    ],
    sizes: ['20g','40g'],
    reviews: 187, rating: 5,
    ingredients: 'Chickpea flour, peanuts, curry leaves, spices & condiments.',
    allergy: 'Contains peanuts. 100% Vegetarian.',
    badge: 'No.1 Quality',
  },
  {
    id: 4,
    name: 'Mixture Namkeen',
    category: 'Spicy Namkeen',
    price: 200, unit: '500g',
    description: 'Kushal premium mixture namkeen — satisfying cravings the healthy way.',
    image: '/images/products/mixture_namkeen_jpg.jpeg',
    sizeOptions: [{ size: '500g', price: 200 }],
    sizes: ['500g'],
    reviews: 198, rating: 5,
    ingredients: 'Sev, boondi, peanuts, chana dal, spices & condiments.',
    allergy: 'Contains peanuts. 100% Vegetarian.',
    badge: "Nepal's No.1",
  },
  {
    id: 5,
    name: 'Chana Chur Namkeen',
    category: 'Spicy Namkeen',
    price: 10, unit: '20g',
    description: 'New pack Kushal Chana Chur — 10% Extra, enjoy with Nepali product.',
    image: '/images/products/chana_chur.png',
    sizeOptions: [
      { size: '20g',  price: 10  },
      { size: '200g', price: 100 },
    ],
    sizes: ['20g','200g'],
    reviews: 143, rating: 4,
    ingredients: 'Chana dal, flattened rice, spices, vegetable oil.',
    allergy: 'May contain traces of gluten and mustard.',
    badge: '10% Extra',
  },
  {
    id: 7,
    name: 'Kushal Aloo Bhujia',
    category: 'Spicy Namkeen',
    price: 10, unit: '15g',
    description: 'Kushal brand premium aloo bhujia — mouth watering flavour, 100% quality.',
    image: '/images/products/aloo_bhujia_final.jpg',
    sizeOptions: [{ size: '15g', price: 10 }],
    sizes: ['15g'],
    reviews: 176, rating: 5,
    ingredients: 'Potato, chickpea flour, vegetable oil, salt, spices.',
    allergy: '100% Vegetarian.',
    badge: '100% Premium',
  },
  {
    id: 8,
    name: 'Bikaneri Bhujia',
    category: 'Spicy Namkeen',
    price: 10, unit: '15g',
    description: 'Classic Bikaneri style thin bhujia — premium quality, mouth watering flavour.',
    image: '/images/products/bikaneri_bhujia.jpg',
    sizeOptions: [{ size: '15g', price: 10 }],
    sizes: ['15g'],
    reviews: 154, rating: 5,
    ingredients: 'Moth bean flour, vegetable oil, black pepper, spices.',
    allergy: '100% Vegetarian.',
    badge: null,
  },
  {
    id: 10,
    name: 'Boondi Mixture Namkeen',
    category: 'Spicy Namkeen',
    price: 10, unit: '28g',
    description: "Kushal boondi mixture — satisfying cravings the healthy way. Nepal's No.1.",
    image: '/images/products/bnOONDI_MIXTURE_STAND.png',
    sizeOptions: [
      { size: '28g',  price: 10  },
      { size: '300g', price: 150 },
    ],
    sizes: ['28g','300g'],
    reviews: 168, rating: 5,
    ingredients: 'Chickpea flour (boondi), vegetable oil, salt, spices.',
    allergy: '100% Vegetarian.',
    badge: "Nepal's No.1",
  },
  {
    id: 11,
    name: 'Boondi Namkeen',
    category: 'Spicy Namkeen',
    price: 10, unit: '28g',
    description: 'Kushal premium boondi — crunchy round boondi in bold spice blend.',
    image: '/images/products/boondi_namkeen.jpg',
    sizeOptions: [
      { size: '28g',  price: 10  },
      { size: '300g', price: 150 },
    ],
    sizes: ['28g','300g'],
    reviews: 145, rating: 4,
    ingredients: 'Chickpea flour, vegetable oil, salt, chilli powder, spices.',
    allergy: '100% Vegetarian.',
    badge: null,
  },
  {
    id: 14,
    name: 'Punjabi Tadka',
    category: 'Spicy Namkeen',
    price: 10, unit: '15g',
    description: 'Kushal Punjabi Tadka — bold Punjabi flavours, 100% premium quality namkeen.',
    image: '/images/products/PUNJABI_TADKKKA_jpg.png',
    sizeOptions: [{ size: '15g', price: 10 }],
    sizes: ['15g'],
    reviews: 156, rating: 5,
    ingredients: 'Chickpea flour, refined oil, Punjabi masala blend, salt.',
    allergy: '100% Vegetarian.',
    badge: '100% Premium',
  },
  {
    id: 15,
    name: 'Mr. Namkeen Chatpata',
    category: 'Spicy Namkeen',
    price: 120, unit: '300g',
    description: 'Mr. Namkeen chatpata mixture — 100% guaranteed natural brand satisfaction.',
    image: '/images/products/mr_namkeen.png',
    sizeOptions: [{ size: '300g', price: 120 }],
    sizes: ['300g'],
    reviews: 173, rating: 4,
    ingredients: 'Sev, peanuts, fried dals, curry leaves, chatpata masala.',
    allergy: 'Contains peanuts. 100% Vegetarian.',
    badge: '100% Guaranteed',
  },
  {
    id: 16,
    name: 'Kushal Moong Dal',
    category: 'Spicy Namkeen',
    price: 10, unit: '12g',
    description: 'Kushal Moong Dal namkeen — rich in quality & taste. Premium, mouth-watering flavour.',
    image: '/images/products/Moong_Dal_rs_10_220x140mm.png',
    sizeOptions: [
      { size: '12g',  price: 10  },
      { size: '175g', price: 100 },
    ],
    sizes: ['12g','175g'],
    reviews: 142, rating: 4,
    ingredients: 'Moong dal, refined oil, salt, turmeric, spices.',
    allergy: '100% Vegetarian.',
    badge: null,
  },
  {
    id: 17,
    name: 'Sadabahar Namkeen',
    category: 'Spicy Namkeen',
    price: 150, unit: '300g',
    description: "Kushal Sadabahar namkeen — satisfying cravings the healthy way. Nepal's No.1.",
    image: '/images/products/sadhabahar.png',
    sizeOptions: [{ size: '300g', price: 150 }],
    sizes: ['300g'],
    reviews: 189, rating: 5,
    ingredients: 'Sev, boondi, peanuts, fried dals, curry leaves, spices.',
    allergy: 'Contains peanuts. 100% Vegetarian.',
    badge: "Nepal's No.1",
  },
  {
    id: 18,
    name: 'Kushal Namkeen Classic',
    category: 'Spicy Namkeen',
    price: 30, unit: '65g',
    description: 'Kushal namkeen — The Brand of Royal Choice. 100% Veg, 100% Guaranteed.',
    image: '/images/products/rnrn_kushal.png',
    sizeOptions: [
      { size: '65g',  price: 30  },
      { size: '225g', price: 100 },
    ],
    sizes: ['65g','225g'],
    reviews: 165, rating: 4,
    ingredients: 'Sev, peanuts, green peas, spices & condiments.',
    allergy: 'Contains peanuts. 100% Vegetarian.',
    badge: 'Royal Choice',
  },
  {
    id: 24,
    name: 'Kushal Nut Cracker',
    category: 'Spicy Namkeen',
    price: 10, unit: '15g',
    description: 'Kushal Nut Cracker — crispy & crunchy, explosion of real taste.',
    image: '/images/products/nut_cracker.png',
    sizeOptions: [{ size: '15g', price: 10 }],
    sizes: ['15g'],
    reviews: 176, rating: 4,
    ingredients: 'Peanuts, chickpea flour, spices, vegetable oil.',
    allergy: 'Contains peanuts. 100% Vegetarian.',
    badge: 'Crispy & Crunchy',
  },
  {
    id: 31,
    name: 'Green Matar Fry',
    category: 'Spicy Namkeen',
    price: 10, unit: '15g',
    description: 'R&R Green Matar Fry — crispy & crunchy fried green peas. Product of Nepal.',
    image: '/images/products/motar.jpg',
    sizeOptions: [{ size: '15g', price: 10 }],
    sizes: ['15g'],
    reviews: 223, rating: 4,
    ingredients: 'Green peas, vegetable oil, timur masala, salt.',
    allergy: '100% Vegetarian.',
    badge: 'Rs.10 Only',
  },
 

  // ── BHUJHA & CHATPATE BHUJHA ───────────────────────────────

   {
    id: 9,
    name: 'Swadisht Bhuja',
    category: 'Bhujha & Chatpate Bhujha',
    price: 80, unit: '300g',
    description: 'Kushal Premium Quality swadisht bhuja — good for health, easy to digest.',
    image: '/images/products/BUJAA-01.png',
    sizeOptions: [{ size: '300g', price: 80 }],
    sizes: ['300g'],
    reviews: 132, rating: 4,
    ingredients: 'Puffed rice, mustard oil, salt, turmeric, cumin.',
    allergy: 'Good for health. Easy to digest. 100% Natural.',
    badge: 'Premium Quality',
  },
  {
    id: 6,
    name: 'Kushal Chatpate',
    category: 'Bhujha & Chatpate Bhujha',
    price: 10, unit: '20g',
    description: 'Tangy & spicy chatpate — original taste, amilo-piro flavour in every bite.',
    image: '/images/products/kushal_chatapate.png',
    sizeOptions: [{ size: '20g', price: 10 }],
    sizes: ['20g'],
    reviews: 211, rating: 5,
    ingredients: 'Puffed rice, tomato powder, onion, chilli, spices.',
    allergy: '100% Vegetarian.',
    badge: 'Original Taste',
  },

  {
    id: 13,
    name: 'Chatpate Bhuja (30g)',
    category: 'Bhujha & Chatpate Bhujha',
    price: 10, unit: '30g',
    description: 'R&R Chatpate Bhuja — bold fire flavour with akbare chutney.',
    image: '/images/products/chatpate_bhuja_new.png',
    sizeOptions: [{ size: '30g', price: 10 }],
    sizes: ['30g'],
    reviews: 201, rating: 5,
    ingredients: 'Puffed rice, sev, tomato chutney powder, spices.',
    allergy: '100% Vegetarian.',
    badge: null,
  },

   {
    id: 12,
    name: 'Bhailpuri Chatpate Bhuja',
    category: 'Bhujha & Chatpate Bhujha',
    price: 10, unit: '20g',
    description: 'Kushal chatpate bhuja — special pack for extra freshness.',
    image: '/images/products/bhailpuri.png',
    sizeOptions: [{ size: '20g', price: 10 }],
    sizes: ['20g'],
    reviews: 289, rating: 5,
    ingredients: 'Puffed rice, sev, tomato chutney powder, spices.',
    allergy: '100% Vegetarian.',
    badge: null,
  },

  // ── FRYUMS ────────────────────────────────────────────────
  {
    id: 19,
    name: 'Korean Hot & Spicy Noodles',
    category: 'Fryums',
    price: 10, unit: '32g',
    description: 'R&R Korean hot & spicy noodles — bold flavour, bold crunch.',
    image: '/images/products/Korean_Hot_Spicy.png',
    sizeOptions: [{ size: '32g', price: 10 }],
    sizes: ['32g'],
    reviews: 324, rating: 5,
    ingredients: 'Wheat flour, palm oil, soy sauce, chilli extract, Korean spice blend.',
    allergy: 'Contains Wheat (Gluten) and Soy.',
    badge: 'Hot & Spicy',
  },
  {
    id: 20,
    name: 'R&R Noodles Yellow',
    category: 'Fryums',
    price: 10, unit: '12g',
    description: 'R&R Kushal Noodles — quick, tasty and satisfying.',
    image: '/images/products/rnr_noodles.png',
    sizeOptions: [{ size: '12g', price: 10 }],
    sizes: ['12g'],
    reviews: 412, rating: 5,
    ingredients: 'Wheat flour, palm oil, vegetable masala, salt.',
    allergy: 'Contains Wheat (Gluten).',
    badge: 'Rs.10 Only',
  },
  {
    id: 25,
    name: 'Palak Paneer Namkeen',
    category: 'Fryums',
    price: 10, unit: '12g',
    description: 'R&R Palak Paneer Namkeen — crunch it, taste it! Unique palak paneer flavour.',
    image: '/images/products/Palak_paneer_Fryums.png',
    sizeOptions: [{ size: '12g', price: 10 }],
    sizes: ['12g'],
    reviews: 198, rating: 5,
    ingredients: 'Maize flour, spinach powder, paneer flavour, vegetable oil, spices.',
    allergy: 'Contains dairy traces. 100% Vegetarian.',
    badge: 'Crunch It',
  },
  {
    id: 26,
    name: 'Big ABCD Lacy Masti',
    category: 'Fryums',
    price: 10, unit: '15g',
    description: "Nepal's No.1 Snacks Product — Big ABCD Lacy Masti.",
    image: '/images/products/ABCD.png',
    sizeOptions: [{ size: '15g', price: 10 }],
    sizes: ['15g'],
    reviews: 445, rating: 5,
    ingredients: 'Maize flour, vegetable oil, salt, flavour enhancers.',
    allergy: '100% Vegetarian.',
    badge: "Nepal's No.1",
  },
  {
    id: 29,
    name: 'Chinese Pasta',
    category: 'Fryums',
    price: 20, unit: '10g',
    description: 'R&R Chinese Pasta — fun snack with FREE tomato ketchup inside!',
    image: '/images/products/pasta.png',
    sizeOptions: [{ size: '10g', price: 20 }],
    sizes: ['10g'],
    reviews: 334, rating: 5,
    ingredients: 'Maize flour, vegetable oil, Chinese masala seasoning.',
    allergy: '100% Vegetarian.',
    badge: 'Free Ketchup',
  },
  {
    id: 30,
    name: 'Chinese Penny Pasta',
    category: 'Fryums',
    price: 20, unit: '20g',
    description: 'R&R Chinese Penny Pasta — Spanish tomato chilli with FREE ketchup inside.',
    image: '/images/products/penny.png',
    sizeOptions: [{ size: '20g', price: 20 }],
    sizes: ['20g'],
    reviews: 291, rating: 5,
    ingredients: 'Wheat flour, vegetable oil, Spanish tomato chilli seasoning.',
    allergy: 'Contains Wheat (Gluten).',
    badge: 'Free Ketchup',
  },
  {
    id: 39,
    name: 'Jungle Janawar',
    category: 'Fryums',
    price: 10, unit: '12g',
    description: 'R&R Jungle Janawar — fun animal-shaped snacks that kids absolutely love!',
    image: '/images/products/Jungle_Janawar.png',
    sizeOptions: [{ size: '12g', price: 10 }],
    sizes: ['12g'],
    reviews: 0, rating: 5,
    ingredients: 'Maize flour, vegetable oil, mild masala seasoning.',
    allergy: '100% Vegetarian. Fun for kids!',
    badge: 'New',
  },
  {
    id: 40,
    name: 'Masala Ponga',
    category: 'Fryums',
    price: 10, unit: '20g',
    description: 'R&R Masala Ponga — chilli puffs with sweet chilli flavour. Kids love it!',
    image: '/images/products/masala_ponga.jpeg',
    sizeOptions: [{ size: '20g', price: 10 }],
    sizes: ['20g'],
    reviews: 0, rating: 5,
    ingredients: 'Maize flour, vegetable oil, sweet chilli masala.',
    allergy: '100% Vegetarian.',
    badge: 'New',
  },

  // ── CHIPS / KURKURE / CHEESE BALLS ────────────────────────
  {
    id: 21,
    name: 'Potato Chips Hot Chilli',
    category: 'Chips/Kurkure/Cheese Balls',
    price: 20, unit: '20g',
    description: 'R&R Potato Chips — typical Nepali taste, hot chilli magic masala flavour.',
    image: '/images/products/Potato.jpg',
    sizeOptions: [{ size: '20g', price: 20 }],
    sizes: ['20g'],
    reviews: 287, rating: 5,
    ingredients: 'Potato, vegetable oil, hot chilli powder, magic masala, salt.',
    allergy: '100% Made from Potato.',
    badge: 'Hot Chilli',
  },
  {
    id: 22,
    name: 'Potato Cracker',
    category: 'Chips/Kurkure/Cheese Balls',
    price: 10, unit: '10g',
    description: 'R&R Potato Cracker — fresh, crispy & tasty.',
    image: '/images/products/potato_cracker_rs_10.png',
    sizeOptions: [
      { size: '10g', price: 10 },
      { size: '20g', price: 20 },
    ],
    sizes: ['10g','20g'],
    reviews: 243, rating: 4,
    ingredients: 'Potato starch, vegetable oil, salt, seasonings.',
    allergy: '100% Vegetarian.',
    badge: 'Rs.10 Only',
  },
  {
    id: 23,
    name: 'Krunchy Sticks Masala Munch',
    category: 'Chips/Kurkure/Cheese Balls',
    price: 5, unit: '7g',
    description: 'R&R Krunchy Sticks — time pass full masti snax! Hot chilli masala munch.',
    image: '/images/products/Rnr_Krunchy_Sticks_Rs_20_Nov_2022.png',
    sizeOptions: [
      { size: '7g',  price: 5  },
      { size: '15g', price: 10 },
      { size: '30g', price: 20 },
      { size: '80g', price: 50 },
    ],
    sizes: ['7g','15g','30g','80g'],
    reviews: 318, rating: 5,
    ingredients: 'Maize flour, vegetable oil, hot chilli powder, masala seasoning.',
    allergy: '100% Vegetarian.',
    badge: 'Hot Chilli',
  },
  {
    id: 37,
    name: 'Cheese Balls',
    category: 'Chips/Kurkure/Cheese Balls',
    price: 60, unit: '50g',
    description: 'R&R Cheese Balls — cheddar cheese flavoured crunchy balls, irresistibly delicious.',
    image: '/images/products/cheese_balls.jpeg',
    sizeOptions: [],
    sizes: [],
    reviews: 120, rating: 5,
    ingredients: 'Maize flour, vegetable oil, cheddar cheese powder, spices.',
    allergy: 'Contains dairy. 100% Vegetarian.',
    badge: 'New',
  },
  {
    id: 38,
    name: 'A-One Chips (Cream N Onion)',
    category: 'Chips/Kurkure/Cheese Balls',
    price: 50, unit: '12g',
    description: 'R&R A-One Potato Chips — cream n onion flavour. 20% extra, crinkle cut.',
    image: '/images/products/aone_chips_green.jpeg',
    sizeOptions: [],
    sizes: [],
    reviews: 130, rating: 5,
    ingredients: 'Potato chips, vegetable oil, cream & onion seasoning.',
    allergy: 'Contains dairy. 100% Vegetarian.',
    badge: '20% Extra',
  },
  {
    id: 46,
    name: 'A-One Chips Potato Chips',
    category: 'Chips/Kurkure/Cheese Balls',
    price: null, unit: '45g',               // ← was TBD (invalid JS); set to null until price is confirmed
    description: 'R&R A-One Potato Chips — cream n onion flavour. 20% extra, crinkle cut.',
    image: '/images/products/Aone chips blue.jpeg',
    sizeOptions: [],
    sizes: [],
    reviews: 130, rating: 5,
    ingredients: 'Potato chips, vegetable oil, cream & onion seasoning.',
    allergy: 'Contains dairy. 100% Vegetarian.',
    badge: '20% Extra',
  },

  // ── PUFFS ─────────────────────────────────────────────────
  {
    id: 27,
    name: 'Gudiya Rani Masala Puff',
    category: 'Puffs',
    price: 10, unit: '15g',
    description: 'Gudiya Rani masala puff — fun, colourful kids snack with tasty masala flavour.',
    image: '/images/products/Gudiya_Rani.png',
    sizeOptions: [{ size: '15g', price: 10 }],
    sizes: ['15g'],
    reviews: 367, rating: 5,
    ingredients: 'Maize flour, vegetable oil, masala seasoning.',
    allergy: '100% Vegetarian.',
    badge: 'Kids Favourite',
  },
  {
    id: 28,
    name: 'Lappan Chappan Long Puff',
    category: 'Puffs',
    price: 10, unit: '20g',
    description: 'Long puff with achari flavour — lappan chappan fun snack for kids.',
    image: '/images/products/lapanchapan.png',
    sizeOptions: [{ size: '20g', price: 10 }],
    sizes: ['20g'],
    reviews: 298, rating: 4,
    ingredients: 'Maize flour, vegetable oil, achari seasoning.',
    allergy: '100% Vegetarian.',
    badge: 'Achari Flavour',
  },

  // ── DIET & HEALTH ─────────────────────────────────────────
 
  {
    id: 32,
    name: 'Poushtik Diet Mixture',
    category: 'Diet & Health',
    price: 160, unit: '400g',
    description: 'High diet protein & fibre mix — your secret weapon for a high-protein, low-calorie gym snack.',
    image: '/images/products/Diet_Mixture.png',
    sizeOptions: [{ size: '400g', price: 160 }],
    sizes: ['400g'],
    reviews: 118, rating: 4,
    ingredients: 'Hill-grown jumli maize, peanuts, chickpea, spices.',
    allergy: '100% Vegetarian. High Protein. No Preservatives.',
    badge: 'High Protein',
  },
  {
    id: 33,
    name: 'Harpal Furandana',
    category: 'Diet & Health',
    price: 150, unit: '400g',
    description: 'Diet mixture furandana — made with special viura and delicious masala.',
    image: '/images/products/harpal_furandana.png',
    sizeOptions: [{ size: '400g', price: 150 }],
    sizes: ['400g'],
    reviews: 97, rating: 4,
    ingredients: 'Flattened rice (viura), peanuts, lentils, hill spices.',
    allergy: '100% Natural. Low Cholesterol.',
    badge: 'Diet Mixture',
  },
  {
    id: 34,
    name: 'Kushal Furandana',
    category: 'Diet & Health',
    price: 160, unit: '450g',
    description: 'Traditional Nepali diet mixture furandana — low cholesterol, best quality.',
    image: '/images/products/furandan_red.jpg',
    sizeOptions: [{ size: '450g', price: 160 }],
    sizes: ['450g'],
    reviews: 112, rating: 4,
    ingredients: 'Flattened rice, peanuts, puffed corn, spices.',
    allergy: 'Low Cholesterol. 100% Natural.',
    badge: 'Best Quality',
  },
  {
    id: 35,
    name: 'Salted Peanuts',
    category: 'Diet & Health',
    price: 10, unit: '15g',
    description: 'Kushal Salted Peanuts — 100% premium quality, lightly salted for the perfect crunch.',
    image: '/images/products/salted.jpg',
    sizeOptions: [
      { size: '15g',  price: 10  },
      { size: '300g', price: 200 },
    ],
    sizes: ['15g','300g'],
    reviews: 203, rating: 5,
    ingredients: 'Peanuts, refined oil, salt.',
    allergy: 'Contains peanuts. 100% Vegetarian.',
    badge: '100% Premium',
  },
  {
    id: 41,
    name: 'Bhutte Ko Makai',
    category: 'Diet & Health',
    price: 160, unit: '400g',
    description: 'Kushal Bhutte Ko Makai — high-protein, low-calorie gym snack.',
    image: '/images/products/die_mixture.jpg',
    sizeOptions: [{ size: '400g', price: 160 }],
    sizes: ['400g'],
    reviews: 0, rating: 5,
    ingredients: 'Hill-grown maize, vegetable oil, spices.',
    allergy: '100% Vegetarian. High Protein.',
    badge: 'New',
  },
 {
    id: 48,
    name: 'Nuts N Seeds',
    category: 'Diet & Health',
    price: null, unit: '300g',               // ← was TBD (invalid JS); set to null until price is confirmed
    description: 'Nuts N Seeds — crispy & crunchy, explosion of real taste.',
    image: '/images/products/Nuts N Seeds.jpeg',
    sizeOptions: [{ size: '300g', price: null }],  // ← same fix
    sizes: ['300g'],
    reviews: 176, rating: 4,
    ingredients: 'Peanuts, chickpea flour, spices, vegetable oil.',
    allergy: 'Contains peanuts. 100% Vegetarian.',
    badge: 'Crispy & Crunchy',
  },
]

// ─────────────────────────────────────────────────────────────
//  TEAM MEMBERS
// ─────────────────────────────────────────────────────────────
export const TEAM = [
  { id: 1, name: 'Bhanu Pandey',   role: 'Founder & Director',      initials: 'BP', image: '' },
  { id: 2, name: 'Mohan Pandey', role: 'Co-Founder & Operations', initials: 'MP', image: '' },
];

// ─────────────────────────────────────────────────────────────
//  TESTIMONIALS
// ─────────────────────────────────────────────────────────────
export const TESTIMONIALS = [
  { id: 1,  text: 'Kushal All In One has the proper Nepali chatpate taste. The namkeen stays crunchy, the masala is balanced, and every packet feels fresh.',          name: 'Prakash Bhatta',       location: 'Pokhara, Kaski',     rating: 5 },
  { id: 2,  text: 'I keep R&R snacks in my shop because customers ask for them again. The packaging looks clean, the price is practical, and the quality is consistent.', name: 'Ramesh Kumar Yadav',   location: 'Butwal, Rupandehi',  rating: 5 },
  { id: 3,  text: 'The mixture namkeen tastes homemade but has professional finishing. It is spicy, crunchy, and perfect with tea for the whole family.',               name: 'Sita Devi Chaudhary',  location: 'Janakpur, Dhanusha', rating: 5 },
  { id: 4,  text: 'Potato chips and kids snacks are always fresh when they arrive. Good crunch, strong flavour, and very reliable for our canteen orders.',             name: 'Dipesh Mahato',        location: 'Biratnagar, Morang', rating: 5 },
  { id: 5,  text: 'R&R products have become regular snacks in our home. The taste feels local, the packets are hygienic, and the delivery is dependable.',             name: 'Sabina Thapa',         location: 'Hetauda, Makwanpur', rating: 5 },
  { id: 6,  text: 'The Korean Hot & Spicy noodles sell very fast in our store. Customers like the bold masala and the packet quality looks trustworthy.',               name: 'Bikash Adhikari',      location: 'Bharatpur, Chitwan', rating: 5 },
  { id: 7,  text: 'I ordered namkeen for our office tea break and everyone liked it. The flavour is not flat, the crunch lasts, and the price is reasonable.',         name: 'Mina Karki',           location: 'Nepalgunj, Banke',   rating: 5 },
  { id: 8,  text: 'Jungle Janawar and Cheese Balls are favourites for children in our family. Fresh packets, nice taste, and no stale smell at all.',                  name: 'Puja Lamichhane',      location: 'Tansen, Palpa',      rating: 5 },
  { id: 9,  text: 'As a retailer, I appreciate that the products are consistent from carton to carton. R&R snacks are easy to recommend to regular customers.',        name: 'Amit Sah',             location: 'Birgunj, Parsa',     rating: 5 },
  { id: 10, text: 'The diet mixture has a clean taste and feels lighter than many other snacks. It is perfect when guests come home for chiya.',                       name: 'Anita Gurung',         location: 'Dharan, Sunsari',    rating: 5 },
  { id: 11, text: 'Chatpate Bhuja has a strong local flavour and the crunch is excellent. It reminds me of snacks we buy during travel, but cleaner packed.',         name: 'Kiran Rai',            location: 'Ilam',               rating: 5 },
  { id: 12, text: 'We use R&R snacks for school canteen supply because the small packs move quickly. Children like the taste and parents trust the hygiene.',          name: 'Laxmi Poudel',         location: 'Damak, Jhapa',       rating: 5 },
  { id: 13, text: 'The masala in the namkeen is balanced very well. It is spicy enough for Nepali taste but does not feel too heavy.',                                 name: 'Roshan KC',            location: 'Dang',               rating: 5 },
  { id: 14, text: 'A-One chips are crispy and the flavour coating is even. Every packet I opened had the same freshness and crunch.',                                  name: 'Manisha Shahi',        location: 'Surkhet',            rating: 5 },
  { id: 15, text: 'For wholesale orders, R&R has been dependable. Cartons arrive properly packed and customers recognize the taste now.',                              name: 'Hari Prasad Nepal',    location: 'Kathmandu',          rating: 5 },
  { id: 16, text: 'Boondi mixture is very good with tea. The texture is light, the spice is clean, and the packet quality feels premium.',                            name: 'Nirmala Magar',        location: 'Baglung',            rating: 5 },
  { id: 17, text: 'My family liked the kids snacks because they are fun and tasty. The products feel fresh, not oily or stale.',                                      name: 'Sanjay Tamang',        location: 'Bhaktapur',          rating: 5 },
  { id: 18, text: 'The snack range has good variety for a small store. Customers can choose noodles, chips, namkeen, and kids snacks from one brand.',                name: 'Rekha Sharma',         location: 'Lalitpur',           rating: 5 },
];
